<template>
  <h2
    v-if="header"
    class="CardHeader"
    :class="header.class"
    :style="calculatedStyle"
    v-html="$t(header.text)"
  />
</template>

<script>
export default {
  name: 'card-header',
  props: {
    header: {
      type: Object
    }
  },
  computed: {
    calculatedStyle() {
      if (this.header.style && this.header.style.sm && this.$mq === 'sm') {
        return { ...this.header.style, ...this.header.style.sm }
      } else if (this.header.style && this.header.style.lg && this.$mq === 'lg') {
        return { ...this.header.style, ...this.header.style.lg }
      } else {
        return this.header.style
      }
    }
  }
}
</script>

<style lang="scss">
</style>
